module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    attrs: {
      "id": "toc"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/SECT02#toc"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/SECT03#toc"
    }
  }, [_vm._v("How to Get the Most Out of This Book")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/SECT04#toc"
    }
  }, [_vm._v("1 The Peculiar Community")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/Text/SECT04#heading_id_8"
    }
  }, [_c('em', [_vm._v("Soul Training: Two-by-Four")])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SECT05#toc",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 The Hopeful Community")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/Text/SECT05#heading_id_8",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Soul Training: Sharing Your Faith")])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SECT06#toc",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 The Serving Community")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/Text/SECT06#heading_id_8",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Soul Training:")]), _vm._v(" "), _c('em', [_vm._v("Treasuring Our Treasures")])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SECT07#toc",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 The Christ-Centered Community")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/Text/SECT07#heading_id_8",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Soul Training:")]), _vm._v(" "), _c('em', [_vm._v("Loving Those We Disagree With")])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SECT08#toc",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 The Reconciling Community")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/Text/SECT08#heading_id_8",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Soul Training:")]), _vm._v(" "), _c('em', [_vm._v("Experiencing Reconciliation")])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SECT09#toc",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 The Encouraging Community")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/Text/SECT09#heading_id_8",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Soul Training:")]), _vm._v(" "), _c('em', [_vm._v("Finding an Accountability Friend")])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SECT10#toc",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 The Generous Community")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/Text/SECT10#heading_id_8",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Soul Training:")]), _vm._v(" "), _c('em', [_vm._v("Stewardship of Resources")])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SECT11#toc",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 The Worshiping Community")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/Text/SECT11#heading_id_8",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Soul Training:")]), _vm._v(" "), _c('em', [_vm._v("Worship")])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SECT12#toc",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 Writing a Soul-Training Plan")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SECT14#toc",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix: Small Group Discussion Guide")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/eNotes#toc",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SECT16#toc",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fa8cef8c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Contents.vue
// module id = 69
// module chunks = 0